<template>
    <el-container>
        <div class="container">
            <div class="searchBox">
              <el-form :inline="true" label-position="left" label-width="100px">
                <el-row>
                  <el-col :span="8" class="leftAlignTtem">
                      <el-form-item label="作番号">
                          <el-input v-model="searchData.mfgNo" placeholder="请输入作番号"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8" class="leftAlignTtem">
                    <el-form-item label="电梯注册码">
                        <el-input v-model="searchData.registerCode" placeholder="请输入电梯注册码"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" class="leftAlignTtem">
                    <el-form-item label="保养周期">
                          <el-select v-model="searchData.maintainDuration" placeholder="请选择保养周期">
                            <el-option
                              v-for="item in maintainDurationOption"
                              :key="item.key"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8" class="leftAlignTtem">
                      <el-form-item label="保养起止日期">
                          <el-date-picker
                            v-model="searchData.contractStarEnd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                          </el-date-picker>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8" class="leftAlignTtem">
                    <el-form-item label="维保状态">
                          <el-select v-model="searchData.maintainStatus" placeholder="请选择维保状态">
                            <el-option
                              v-for="item in maintainStatusOption"
                              :key="item.key"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" class="leftAlignTtem">
                    <el-form-item label="维保员">
                        <el-autocomplete
                          v-model="searchData.maintainer" :fetch-suggestions="queryMaintainer">
                        </el-autocomplete>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8" class="leftAlignTtem">
                    <el-form-item label="合约编号">
                      <el-autocomplete
                          v-model="searchData.contractNo" :fetch-suggestions="queryContract">
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" class="leftAlignTtem">
                    <el-form-item label="合约类型">
                       <el-select v-model="searchData.contractType" placeholder="请选择合约类型">
                         <el-option label="全部" value="0"  key="0"/>
                         <el-option label="直销" value="1"  key="1"/>
                         <el-option label="平台" value="2"  key="2"/>
                       </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="gapRow">
                  <el-col :span="8"></el-col>
                  <el-col :span="16" class="leftAlignTtem">
                    <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
                    <el-button  @click="reset" style="margin-left: 5px;">重置</el-button>
                    <el-button type="warning" style="margin-left: 5px;" icon="el-icon-edit" @click="openBatchUpdateDialog" v-if="this.loginName === 'admin' || this.clientIds || this.loginName === '王萍' ">批量更新维保员</el-button>
                    <el-button type="warning" style="margin-left: 5px;" icon="el-icon-edit" @click="openLocationUpdateDialog" v-if="this.loginName === 'admin' || this.loginName === '王萍'">批量更新作番坐标</el-button>
                    <el-button  @click="exportExcel" type="success" style="margin-left: 5px;" icon="el-icon-collection"  >导出Excel</el-button>
                    <!-- <el-button type="info" style="margin-left: 5px;" icon="el-icon-tickets">详情</el-button>

                    <el-button type="success" style="margin-left: 5px;" icon="el-icon-collection">导出</el-button>-->
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="contentBox">
              <el-table
              :data="tableData"
              @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="mfgNo" label="作番号"></el-table-column>
                <el-table-column prop="bonusAmount" label="维保津贴"></el-table-column>
                <el-table-column prop="registerCode" label="注册码"></el-table-column>
                <el-table-column prop="contractNo" label="合约编号"></el-table-column>
                <el-table-column prop="contractName" label="合约名称"></el-table-column>
                <el-table-column prop="contractStartEnd" label="保养开始日期"></el-table-column>
                <el-table-column prop="maintainStatus" label="维保状态"></el-table-column>
                <el-table-column prop="maintainDuration" label="保养周期"></el-table-column>
                <el-table-column prop="maintainer" label="当月维保员"></el-table-column>
                <el-table-column prop="mfgAddress" label="作番地址"></el-table-column>
              </el-table>
              <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.pageIndex"
                    :page-sizes="[10,20,30,40,50,100]"
                    :page-size="searchData.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
                <el-dialog
                  :visible.sync="batchUpdateDialogVisible"
                  width="30%"
                  title="批量更新作番维保员"
                  :modal="true"
                  :draggable="true"
                  :close-on-click-modal="false"
                  :before-close="handleUpdateClose"
                >
                  <el-form :model="batchUpdateData" label-width="80px">
                    <el-row>
                      <el-col :span="24">
                        <span style="color:red;font-weight: bold; word-break: break-all; word-wrap: break-word;">注意：生效日期为当月15号之前计入当月维保津贴台数 15号之后计入下月台数 只能选取本月和之后的日期</span>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 20px;">
                      <el-col :span="24">
                        <el-form-item label="维保员">
                            <el-autocomplete
                              v-model="batchUpdateData.maintainer" :fetch-suggestions="queryMaintainer">
                            </el-autocomplete>
                        </el-form-item>
                    </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="生效日期">
                          <el-date-picker
                              v-model="batchUpdateData.effectiveDate"
                              type="date"
                              placeholder="选择生效日期"
                              :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    </el-row>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="handleUpdateClose">取 消</el-button>
                    <el-button type="primary" @click="handleMaintainerUpdate">确 定</el-button>
                  </div>
                </el-dialog>
                <el-dialog
                :visible.sync="locationUpdateDialog"
                width="30%"
                title="批量更新作番坐标"
                :modal="true"
                :draggable="true"
                :close-on-click-modal="false"
                :before-close="handleLocationUpdateClose"
                >
                  <el-form :model="batchUpdateLocationData" label-width="160px">
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="高德经度">
                          <el-input v-model="batchUpdateLocationData.longitude" placeholder="请输入经度" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="高德维度">
                          <el-input v-model="batchUpdateLocationData.latitude" placeholder="请输入纬度" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="handleLocationUpdateClose">取 消</el-button>
                    <el-button type="primary" @click="handleLocationUpdate">确 定</el-button>
                  </div>
                </el-dialog>
            </div>
        </div>

    </el-container>
</template>
<script>
import request from '@/lib/utils'

export default {
  name: 'mfgmanage',
  data () {
    return {
      headerObj: {
        'auth-token': ''
      },
      searchData: {
        mfgNo: '',
        maintainStatus: '1',
        maintainDuration: '',
        contractStarEnd: [],
        registerCode: '',
        maintainer: '',
        contractNo: '',
        contractType: '1',
        pageIndex: 1,
        pageSize: 10
      },
      batchUpdateData: {
        maintainer: '',
        effectiveDate: ''
      },
      batchUpdateLocationData: {
        longitude: '',
        latitude: ''
      },
      maintainStatusOption: [{key: 0, value: '', label: '请选择'}, {key: 1, value: '1', label: '在保'}, {key: 2, value: '2', label: '丢保'}, {key: 3, value: '3', label: '恰商中'}],
      maintainDurationOption: [{key: 0, value: '', label: '请选择'}, {key: 1, value: '2次/1月', label: '半月保'}, {key: 2, value: '1次/3月', label: '季保'}, {key: 3, value: '1次/6月', label: '半年保'}],
      maintainers: [],
      contracts: [],
      tableData: [],
      contractTypeOption: [{key: 0, value: '', label: '请选择合约类型'}, {key: 1, value: '1', label: '维保'}, {key: 2, value: '2', label: '修理'}],
      total: 0,
      batchUpdateDialogVisible: false,
      locationUpdateDialog: false,
      pickerOptions: {
        disabledDate (time) {
          const today = new Date()
          const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
          return time.getTime() < startOfMonth.getTime()
        }
      },
      selectedRows: [],
      clientIds: '',
      loginName: ''
    }
  },
  created () {

  },
  computed: {

  },
  methods: {
    queryMaintainer (queryString, cb) {
      let searchResults = this.maintainers
      searchResults = queryString ? searchResults.filter(item => item.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || item.workNo.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : searchResults
      let cbResults = searchResults.map(item => {
        item.value = item.name + '(' + item.workNo + ')'
        return item
      })
      // console.log(cbResults)
      cb(cbResults)
    },
    queryContract (queryString, cb) {
      let searchResults = this.contracts
      searchResults = queryString ? searchResults.filter(item => item.contractNo.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || item.customerName.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : searchResults
      if (this.searchData.contractType !== '') {
        if (this.searchData.contractType === '1') {
          searchResults = searchResults.filter(item => item.contractNo.toUpperCase().startsWith('M'))
        }
        if (this.searchData.contractType === '2') {
          searchResults = searchResults.filter(item => item.contractNo.toUpperCase().startsWith('X'))
        }
      }
      let cbResults = searchResults.map(item => {
        item.value = item.contractNo + '(' + item.customerName + ')'
        return item
      })
      // console.log(cbResults)
      cb(cbResults)
    },
    search () {
      console.log(this.searchData)
      request.post('/mfgMaintain/queryMfgMaintainInfo', this.searchData).then(res => {
        this.tableData = res.obj.list
        this.total = res.obj.total
      })
    },
    reset () {
      this.searchData = {
        mfgNo: '',
        maintainStatus: '1',
        maintainDuration: '',
        contractStarEnd: [],
        registerCode: '',
        maintainer: '',
        contractNo: ''
      }
    },
    initMaintainer () {
      request.get('/mfgManager/queryBriefMaintainer').then(res => {
        this.maintainers = res.obj
      })
    },
    handleSizeChange (cureentSize) {
      this.searchData.pageSize = cureentSize
      this.pageIndex = 1
      this.search()
    },
    handleCurrentChange (currentPage) {
      this.searchData.pageIndex = currentPage
      this.search()
    },
    openBatchUpdateDialog () {
      if (this.selectedRows.length === 0) {
        this.$message({
          type: 'warning',
          message: '至少需要选择一台重新分配维保员的作番'
        })
      } else {
        this.batchUpdateDialogVisible = true
      }
    },
    handleUpdateClose () {
      this.batchUpdateDialogVisible = false
    },
    handleLocationUpdateClose () {
      this.locationUpdateDialog = false
    },
    handleMaintainerUpdate () {
      if (this.selectedRows.length === 0) {
        this.$message({
          type: 'warning',
          message: '至少需要选择一台重新分配维保员的作番'
        })
        return
      }
      if (!this.batchUpdateData.maintainer) {
        this.$message({
          type: 'warning',
          message: '维保员信息必填'
        })
        return
      }
      if (!this.batchUpdateData.effectiveDate) {
        this.$message({
          type: 'warning',
          message: '生效日期必填'
        })
        return
      }
      const requestData = {
        mfgInfos: this.selectedRows,
        maintainer: this.batchUpdateData.maintainer,
        effectiveDate: this.batchUpdateData.effectiveDate
      }
      request.post('/mfgMaintain/batchUpdateMfgMaintainer', requestData).then(
        res => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '批量更新作番维保人员成功'
            })
            this.search()
            this.batchUpdateDialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        }
      )
    },
    handleSelectionChange (val) {
      this.selectedRows = val
    },
    openLocationUpdateDialog () {
      if (this.selectedRows.length === 0) {
        this.$message({
          type: 'warning',
          message: '至少需要选择一台修改坐标的作番'
        })
      } else {
        this.locationUpdateDialog = true
      }
    },
    handleLocationUpdate () {
      if (this.selectedRows.length === 0) {
        this.$message({
          type: 'warning',
          message: '至少需要选择一台修改坐标的作番'
        })
        return
      }
      if (!this.batchUpdateLocationData.latitude || !this.batchUpdateLocationData.longitude) {
        this.$message({
          type: 'warning',
          message: '经度和维度坐标信息必填'
        })
        return
      }
      const requestData = {
        mfgInfos: this.selectedRows,
        latitude: this.batchUpdateLocationData.latitude,
        longtitude: this.batchUpdateLocationData.longitude
      }
      request.post('/mfgMaintain/batchUpdateMfgLocation', requestData).then(
        res => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '批量更新作番坐标成功'
            })
            this.search()
            this.locationUpdateDialog = false
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        }
      )
    },
    exportExcel () {
      let token = localStorage.getItem('auth-token')
      window.open(process.env.API_URL + 'mfgMaintain/exportMfgMaintainInfo?auth_token=' + token + '&param=' + encodeURIComponent(JSON.stringify(this.searchData)), '_blank')
    }

  },
  mounted () {
    this.headerObj['auth-token'] = localStorage.getItem('auth-token')
    this.initMaintainer()
    this.search()
    request.get('/user/queryLoginUser').then(res => {
      this.clientIds = res.obj.clientId
      this.loginName = res.obj.realName
    }
    )
  }
}

</script>

<style  scoped>
 .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:90% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .centerAlignItem{
    text-align: center;
  }

  .rightAlignItem{
    text-align: right;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-col{
    border: 1px solid transparent;
  }

  .contentBox{
    width: 100%;
    margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/page/subPage/mfgmanager.vue